import { render, staticRenderFns } from "./ViewObservation.vue?vue&type=template&id=4fc8f35a&"
import script from "./ViewObservation.vue?vue&type=script&lang=js&"
export * from "./ViewObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports